import Token from '@/di/di.token'

import useDi from '../useDi'

export default function useAssignmentService() {
  const { container } = useDi()
  const service = container.get(Token.ASSIGNMENT_SERVICE)
  return { service }
}
